
import { SummaryGridDataObjectModel } from './summary-grid-data-object.model';

export class SummaryGridDataModel {
    [key: string]: SummaryGridDataObjectModel[];
}
